<template>
    <div id="kpiList">
      <div class="content-header withgray">
        <i class="content-header-nav el-icon-arrow-left" @click="toBack"></i>
        {{this.title}}
        <el-button type="primary" class="content-header-filter" size="mini" @click="openFilter">筛选</el-button>
      </div>
      <div class="content-body withwhite">
       <div class="box">
          <div class="chart" v-loading="chartLoading">
              <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
              <div class="chart-title">MN</div>
              <div id="MN" style="width: 98%;height:400px;"></div>
          </div>
          <div class="chart">
              <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
              <div class="chart-title">YL</div>
              <div id="YL" style="width: 98%;height:400px;"></div>
          </div>
          <el-row>
            <el-col :span="12"><div class="chart-title">零售价MN/YL</div><div id="Retail" style="width: 98%;height:400px;"></div></el-col>
            <el-col :span="12"><div class="chart-title">折后价MN/YL</div><div id="Off" style="width: 98%;height:400px;"></div></el-col>
          </el-row>
       </div>
      </div>
      
      <el-dialog title="筛选" :visible.sync="showFilter" :show-close="false" customClass="customWidth" :close-on-click-modal="false">
      <el-form :model="queryParams" size="mini" label-width="80px">
        <el-form-item label="开始时间">
          <el-date-picker v-model="queryParams.sDate" type="date" format="yyyy年MM月dd日" :clearable="false" :editable="false" value-format="yyyy-MM-dd" placeholder="开始时间" class="fixwidth"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="queryParams.eDate" type="date" format="yyyy年MM月dd日" :clearable="false" :editable="false" value-format="yyyy-MM-dd" placeholder="结束时间" class="fixwidth"></el-date-picker>
        </el-form-item>
        <el-form-item label="所属区域">
          <el-cascader style="width:50%;" ref="cas_region" :show-all-levels="false" change-on-select clearable :options="regionCascaders" v-model="regionIds" placeholder="请选择区域" class="fixwidth">
          </el-cascader>
          <br><i v-if="regionIds.length>0" class="el-dialog__close el-icon el-icon-close showfilter-region-clear" @click="clearRegion">清空（默认全国）</i>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doFilter">完成筛选</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    </div>
  </template>
  <script>
  import { message, getBaseUrl,getKPIRegionCascaderOption,getReport1} from "../../api/api";
  import libs from "../../utils/libs";
  import moment from "moment";
  import store from "../../utils/storage";
  import echarts from 'echarts';
  
  const animationDuration = 6000

  export default {
    data() {
      return {
        uid:0,
        teamTab:'Date',
        title:'',
        showFilter:false,
        searchLoading:false,
        chartLoading: false,
        regionCascaders:[],
        regionIds:[],
        queryParams:{
          sDate:moment().subtract(8, "days").format("YYYY-MM-DD"),
          eDate:moment().subtract(1, "days").format("YYYY-MM-DD"),
          
          regionId:0,
          userId:1,
          reportModule:'',
          reportType:1
        },
        tableDatas:[],
        tableDatas_MN:[],
        tableDatas_YL:[],
        tableDatas_Retail:[],
        tableDatas_Off:[],
        chartTitle_MN:'',
        chartTitle_YL:'',
        chartTitle_Retail:'',
        chartTitle_Off:'',
        legendData_MN:[],
        legendData_YL:[],
        xAxisData:[],
        seriesData:[],
        dimensionsData:[],


      };
    },
    mounted() {
     this.uid=this.$route.params.uid;
     this.queryParams.userId=this.$route.params.uid;
      this.title=this.$route.params.title;
      this.queryParams.reportModule=this.$route.params.module;
      //console.log(this.teamTab);
      this.getRegionCascader();
       //this.type=this.$route.params.type;
       this.chartTitle_MN=this.queryParams.sDate+'至'+this.queryParams.eDate;
       this.chartTitle_YL=this.queryParams.sDate+'至'+this.queryParams.eDate;
       this.chartTitle_Retail=this.queryParams.sDate+'至'+this.queryParams.eDate;
       this.chartTitle_Off=this.queryParams.sDate+'至'+this.queryParams.eDate;
       this.getMNData();
       //console.log(this.tableDatas_MN);
       //this.search('YL');
       //console.log(this.tableDatas_YL);
       //this.search('Retail');
       //this.search('Off');
       
       
    },
    methods: {
      toBack(){
        history.back();
      },
      openFilter(){
        this.showFilter=true;       
      },
     clearRegion(){
        this.regionIds=[];
      },
      getMNData(){
        this.chartLoading=true;
        this.queryParams.reportType=1;
        this.queryParams.regionId = this.regionIds.length>0? this.regionIds[this.regionIds.length - 1]:0;
        getReport1(this.queryParams).then(res=>{
          if(res.data.Code!=1) return;
          this.tableDatas=res.data.Data.datatable;
          //console.log(this.tableDatas);
          this.splitData(this.queryParams.reportType);
          this.initChart('MN',this.chartTitle_MN);
           this.getYLData();
           this.chartLoading=false;
        }
        );
      },
      getYLData(){
        this.queryParams.reportType=2;
        this.queryParams.regionId = this.regionIds.length>0? this.regionIds[this.regionIds.length - 1]:0;
        getReport1(this.queryParams).then(res=>{
          if(res.data.Code!=1) return;
          this.tableDatas=res.data.Data.datatable;
          //console.log(this.tableDatas);
          this.splitData(this.queryParams.reportType);
          this.initChart("YL",this.chartTitle_YL);
          this.getRetailData();
        }
        );
      },
      getRetailData(){
        this.queryParams.reportType=3;
        this.queryParams.regionId = this.regionIds.length>0? this.regionIds[this.regionIds.length - 1]:0;
        getReport1(this.queryParams).then(res=>{
          if(res.data.Code!=1) return;
          this.tableDatas=res.data.Data.datatable;
          
          this.splitData(this.queryParams.reportType);
          this.initChartPie("Retail",this.chartTitle_Retail);
          this.getOffData();
        }
        );
      },
       getOffData(){
        this.queryParams.reportType=4;
        this.queryParams.regionId = this.regionIds.length>0? this.regionIds[this.regionIds.length - 1]:0;
        getReport1(this.queryParams).then(res=>{
          if(res.data.Code!=1) return;
          this.tableDatas=res.data.Data.datatable;
          
          this.splitData(this.queryParams.reportType);
          this.initChartPie("Off",this.chartTitle_Off);
        }
        );
      },
      doFilter(){
        if(this.$refs['cas_region'].currentLabels.length>0){
          this.chartTitle_MN=this.queryParams.sDate+'至'+this.queryParams.eDate+' '+this.$refs['cas_region'].currentLabels[this.$refs['cas_region'].currentLabels.length-1];
          this.chartTitle_YL=this.queryParams.sDate+'至'+this.queryParams.eDate+' '+this.$refs['cas_region'].currentLabels[this.$refs['cas_region'].currentLabels.length-1];
          this.chartTitle_Retail=this.queryParams.sDate+'至'+this.queryParams.eDate+' '+this.$refs['cas_region'].currentLabels[this.$refs['cas_region'].currentLabels.length-1];
          this.chartTitle_Off=this.queryParams.sDate+'至'+this.queryParams.eDate+' '+this.$refs['cas_region'].currentLabels[this.$refs['cas_region'].currentLabels.length-1];
        }else{
          this.chartTitle_MN=this.queryParams.sDate+'至'+this.queryParams.eDate;
          this.chartTitle_YL=this.queryParams.sDate+'至'+this.queryParams.eDate;
          this.chartTitle_Retail=this.queryParams.sDate+'至'+this.queryParams.eDate;
          this.chartTitle_Off=this.queryParams.sDate+'至'+this.queryParams.eDate;
        }
         
        //console.log( this.$refs['cas_region'].currentLabels);
        this.getMNData();
        this.showFilter=false;
        
      },
      splitData(reportType){
        //this.seriesData=this.ChartData_Series(this.tableDatas);
        //console.log(this.tableDatas);
        
        this.legendData=this.ChartData_Legend(this.tableDatas);
        if(reportType==3||reportType==4){//柱状图要的数据
          this.seriesData=this.ChartData_Series(this.tableDatas);
          this.dimensionsData=this.ChartData_Dimensions(this.tableDatas);
        }
        

      },
      
      ChartData_Legend(dt){//
        var newArr=[];
        for(var i=0;i<dt.length;i++){
          newArr.push(dt[i].name);
        }
        return newArr;
      },
      ChartData_Series(){
        var newArr=[];
        var Obj={}; 
          Obj={
                type:'bar',
                stack:'vistors',
                barWidth:'70%',
                label:{
                    normal: {
                        show: true,
                        color:'black',//字体黑色
                        fontSize: 10,
                        position: 'inside'//显示在中间。insideRight
                    }
                  },
                animationDuration:2800,
                animationEasing:'cubicInOut'
                };
        var firstObj={};
        firstObj=this.tableDatas[0];
        for(var x in firstObj){
          if(x!='product')
          newArr.push(Obj);
        }
        return newArr;
      },
       ChartData_Dimensions(){//第一列必须是product
        var newArr=['product'];
        var firstObj={};
        firstObj=this.tableDatas[0];
        for(var x in firstObj){
          if(x!='product')
          newArr.push(x);
        }
        return newArr;
      },
      getRegionCascader() {
        getKPIRegionCascaderOption(1).then(res => {
          if (res.data.Code != 1) return;
          var arr=[];
          arr=res.data.Data[0].children;//去掉第一层全国
          //arr = this.filter(res.data.Data,3)[0].children;//去掉level=3及以下数据
          //去掉第一层全国，并且重置全国下面的parentKey
          for(var i=0;i<arr.length;i++){ //去掉最后一层
               arr[i].parentKey=null;
               var child=[];
               if(arr[i].children && arr[i].children.length){
                 child=arr[i].children;
                 for(var j=0;j<child.length;j++){
                   child[j].children=null;
                 }
               }
               this.regionCascaders.push(arr[i]) ;
          }
        });
      },

      initChart(item,ctitle){
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById(item));
        //var myChartYL = echarts.init(document.getElementById('YL'));
        var option = {
          aria: {
              show: true
          },
          title: {
              text:ctitle,
                textStyle:{
                    //文字颜色
                    color:'#000000',
                    //字体风格,'normal','italic','oblique'
                    fontStyle:'normal',
                    //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
                    fontWeight:'bold',
                    //字体系列
                    fontFamily:'sans-serif',
                    //字体大小
            　　　　 fontSize:10,
                    
                },
                left:'left'
          },
          tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
          legend: {
            //left: 'center',
             orient : 'horizontal',
             x : 'center',
            bottom: '0',//图和下面的距离，如饼图和产品买赠...的中间间距
            data: this.legendData,
          },
          //calculable: true,
          series: [
              {
                  //name: '访问来源',
                  type: 'pie',
                  data: this.tableDatas,
                  radius : '60%',//饼图大小
                  // animationEasing: 'cubicInOut',
                  // animationDuration: 2600
                  label:{
                    normal:{
                      formatter: '{b} \n {d}% ',
                      //formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                    //backgroundColor: '#eee',
                   // borderColor: '#aaa',
                    //borderWidth: 1,
                    //borderRadius: 4,
                    }
                  }
              }
          ]
      };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      },
      initChartPie(item,ctitle){
        console.log(this.dimensionsData);
          console.log(this.tableDatas);
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById(item));

        // 指定图表的配置项和数据
        var option = {
            title: {
                //text: 'aa',
                text:ctitle,
                textStyle:{
                    //文字颜色
                    color:'#000000',
                    //字体风格,'normal','italic','oblique'
                    fontStyle:'normal',
                    //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
                    fontWeight:'bold',
                    //字体系列
                    fontFamily:'sans-serif',
                    //字体大小
            　　　　 fontSize:0,
                    
                },
                left:'left'
            },
            //tooltip: {},
            legend: {
                bottom:-2
            },
            dataset: {
                //dimensions: ['product', '2015', '2016', '2017'],
                dimensions: this.dimensionsData,
                source: this.tableDatas
            },
            xAxis: {
              type: 'category',
              //boundaryGap: false,X轴从0开始
              axisTick: {
                //show: false
                alignWithLabel: true//X轴下面加点
              },
              axisLabel : {//坐标轴刻度标签的相关设置。
                interval:0  //每隔都显示；1每隔1个显示
                ,rotate:"45"
            }
            },
            grid: {
              left: 10,
              right: 30,
              bottom: 60,
              top: 30,
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              //axisPointer: {
              //  type: 'cross'
              //},//去掉点击后出现的横向虚线
              position: [20, 20],//当提示框被遮挡，可以这么设置
              padding: [5, 10]
            },
            yAxis: {
              axisTick: {
                show: false
              },
              axisLabel: {
                formatter: function (val) {
                    return val + '%';
                }
              },
            },
            color: ['#f35000', '#f39800', '#9977e4', '#2ec8ca', '#B4FF00', '#A09C83'],//堆叠各段的颜色
            series:this.seriesData
            
        };
        myChart.setOption(option);
      },
    }
  };
  </script>
  
  <style scoped>
  @import "../../assets/css/kpi/kpi.css";
  </style>

  <style>
      .customWidth {
   min-width:400px;
}

      </style>


// WEBPACK FOOTER //
// src/components/kpi/ModernPromotion.vue